import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

export interface ConfirmDialogData {
  title?: string;
  message: string;
  confirmBtn?: string;
  cancelBtn?: string;
  /** style the confirm button as destructive (e.g. revoke / delete) */
  danger?: boolean;
}

/**
 * Reusable yes/no confirmation in the app's own dialog shell, replacing native window.confirm()
 * (which is auto-dismissed in automated/embedded browsers and looks nothing like the rest of the UI).
 * Open with MatDialog and read the boolean result from afterClosed(): true = confirmed.
 */
@Component({
  selector: 'app-confirm-dialog',
  templateUrl: './confirm-dialog.component.html',
  styleUrls: ['./confirm-dialog.component.css'],
  standalone: false
})
export class ConfirmDialogComponent {
  constructor(
    private dialogRef: MatDialogRef<ConfirmDialogComponent, boolean>,
    @Inject(MAT_DIALOG_DATA) public data: ConfirmDialogData
  ) {
    dialogRef.disableClose = true;
  }

  cancel(): void {
    this.dialogRef.close(false);
  }

  confirm(): void {
    this.dialogRef.close(true);
  }
}
